import { api } from '../index';
import { encode } from '@/utils/etc.js';

const prefix = '/api/retailAdmin/';

export function apiSelectRetailOrderListInAdm(ship_to_code, order_status, order_date_from, order_date_to, selected_sales_group, paging_yn, page_size, page_no) {
	return api.get(prefix + 'selectRetailOrderListInAdm', { params: { ship_to_code, order_status, order_date_from, order_date_to, selected_sales_group, paging_yn, page_size, page_no } });
}

export function apiSelectRetailOrderDetail(order_no) {
	return api.get(prefix + 'selectRetailOrderDetail', { params: { order_no } });
}

export function apiAcceptRetailOrder(order) {
	return api.post(prefix + 'acceptRetailOrder', order);
}

export function apiAcceptRetailOrders(order_nos) {
	return api.get(prefix + 'acceptRetailOrders', { params: { order_nos: encode(order_nos) } });
}

export function apiRejectRetailOrder(order) {
	return api.post(prefix + 'rejectRetailOrder', order);
}

export function apiRejectRetailOrders(order_nos, status_reason) {
	return api.get(prefix + 'rejectRetailOrders', { params: { order_nos: encode(order_nos), status_reason: status_reason } });
}
